import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";

const Footer = () => {
    return (
        <div id="footer">
            <div className="footer-wrapper xmt-16 xmt-lg-20">
                <div className="container">
                    <div className="row">
                        <div className="col-12 order-2 order-lg-1">
                            <div
                                className="register-banner d-block d-md-flex text-center justify-content-between align-items-center xp-8 xpr-md-10 xpl-md-10 xmt-16 xmt-lg-0">
                                <div className="text"><h2>برای اطلاع از آخرین تخفیف‌ها و جشنواره‌ها ثبت‌نام
                                    کنید. </h2>
                                </div>
                                <div className="register-banner-button xmt-8 xmt-md-0">
                                    <Link to="/login">ثبت نام</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 order-1 order-lg-2 xmt-lg-20 logo-slide xpx-0">
                            <div className="swiper footer-logo-sayman">
                                <div className="swiper-wrapper">
                                    <div className="swiper-slide">
                                        <div
                                            className="special-footer-box d-flex justify-content-center align-items-center flex-column">
                                            <div className="img">
                                                <IconName name="original-product" className="icon"/>
                                            </div>
                                            <div className="text">
                                                <p>ضمانت اصل بودن کالا</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="swiper-slide">
                                        <div
                                            className="special-footer-box d-flex justify-content-center align-items-center flex-column">
                                            <div className="img">
                                                <IconName name="warranty" className="icon"/>
                                            </div>
                                            <div className="text">
                                                <p>گارانتی ۷ روز برگشت</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div
                                            className="special-footer-box d-flex justify-content-center align-items-center flex-column">
                                            <div className="img">
                                                <IconName name="fast-send" className="icon"/>
                                            </div>
                                            <div className="text">
                                                <p>ارسال سریع کالا</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div
                                            className="special-footer-box d-flex justify-content-center align-items-center flex-column">
                                            <div className="img">
                                                <IconName name="payment-spot" className="icon"/>
                                            </div>
                                            <div className="text">
                                                <p>پرداخت در محل</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="number-phone d-flex xmt-16 xmt-lg-20 d-flex justify-content-center align-items-center xp-6">
                    <span className="d-inline-block pml-32">تلفن مشاوره</span>
                    <div className="d-inline-flex flex-column align-items-end xmr-8">
                        <a dir="ltr" href="tel:+984151180000">۰۴۱-۵۱۱۸۰۰۰۰</a>
                        <a dir="ltr" href="tel:+984135577000">۰۴۱-۳۵۵۷۷۰۰۰</a>
                    </div>
                </div>
                <div className="footer-links-wrapper xmt-16 xmt-lg-20">
                    <div className="container">
                        <div className="row">
                            <div className="col-6 col-sm-4 col-lg-2">
                                <div className="links-box">
                                    <h3 className="xmb-3 xmb-lg-5">سایمان دیجیتال</h3>
                                    <ul className="list-unstyled">
                                        <li><a href="#">تماس با ما</a></li>
                                        <li><a href="#">درباره ما</a></li>
                                        <li><a href="#">بلاگ</a></li>
                                        <li><a href="#">فرصت های شغلی</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-6 col-sm-4 col-lg-2">
                                <div className="links-box">
                                    <h3 className="xmb-3 xmb-lg-5">راهنمای خرید</h3>
                                    <ul className="list-unstyled">
                                        <li><a href="#">نحوه ثبت سفارش</a></li>
                                        <li><a href="#">رویه ارسال</a></li>
                                        <li><a href="#">شیوه های پرداخت</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-6 col-sm-4 col-lg-2">
                                <div className="links-box">
                                    <h3 className="xmb-3 xmb-lg-5 xmt-3 xmt-md-0">پشتیبانی</h3>
                                    <ul className="list-unstyled">
                                        <li><a href="#">پرسش های متداول</a></li>
                                        <li><a href="#">رویه های بازگرداندن کالا</a></li>
                                        <li><a href="#">شرایط استفاده</a></li>
                                        <li><a href="#">حریم خصوصی</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-6 col-sm-4 col-lg-2">
                                <div className="links-box">
                                    <h3 className="xmb-3 xmb-lg-5 xmt-4 xmt-lg-0">محصولات</h3>
                                    <ul className="list-unstyled">
                                        <li><a href="#">گوشی موبایل</a></li>
                                        <li><a href="#">تبلت</a></li>
                                        <li><a href="#">لپ تاپ</a></li>
                                        <li><a href="#">ساعت هوشمند</a></li>
                                        <li><a href="#">خانه هوشمند</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-6 col-sm-4 col-lg-2">
                                <div className="links-box">
                                    <ul className="list-unstyled xmt-6 xmt-lg-12">
                                        <li><a href="#">کنسول بازی</a></li>
                                        <li><a href="#">لوازم جانبی</a></li>
                                        <li><a href="#">گوشی موبایل</a></li>
                                        <li><a href="#">تبلت</a></li>
                                        <li><a href="#">لپ تاپ</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-6 col-sm-4 col-lg-2">
                                <div className="links-box">
                                    <ul className="list-unstyled xmt-6 xmt-lg-12">
                                        <li><a href="#">گوشی موبایل</a></li>
                                        <li><a href="#">تبلت</a></li>
                                        <li><a href="#">لپ تاپ</a></li>
                                        <li><a href="#">ساعت هوشمند</a></li>
                                        <li><a href="#">خانه هوشمند</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="description-footer-wrapper xmt-16 xpt-10 xpb-10">
                        <div
                            className="social-media-icons d-flex justify-content-between align-items-center flex-column-reverse flex-lg-row">
                            <div className="social-media">
                                <ul className="nav list-unstyled">
                                    <li className="nav-item xml-4">
                                        <a href="#"><IconName name="telegram" className="icon"/></a>
                                    </li>
                                    <li className="nav-item xml-4">
                                        <a href="#"><IconName name="instagram" className="icon"/></a>
                                    </li>
                                    <li className="nav-item xml-4">
                                        <a href="#"><IconName name="youtube" className="icon"/></a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#"><IconName name="aparat" className="icon"/></a>
                                    </li>
                                </ul>
                            </div>

                            <div className="symbol-trust xmt-16 xmb-16 xmt-lg-0 xmb-lg-0">
                                <ul className="nav list-unstyled">
                                    <li className="nav-item xml-8">
                                        <a href="#"><IconName name="Symbol-of-trust-1" className="icon"/></a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="#"><IconName name="Symbol-of-trust-2" className="icon"/></a>
                                    </li>
                                </ul>
                            </div>
                            <div className="app-store text-center d-flex justify-content-center">
                                <ul className="nav list-unstyled">
                                    <li className="nav-item xml-3">
                                        <a href="#">
                                            <span>SibApp</span>
                                            <i><IconName name="sib-app" className="icon"/></i>
                                        </a>
                                    </li>
                                    <li className="nav-item xml-3">
                                        <a href="#">
                                            <span>CafeBazaar</span>
                                            <i><IconName name="bazzar" className="icon"/></i>
                                        </a>
                                    </li>
                                    <li className="nav-item g-play">
                                        <a href="#">
                                            <span>Google Play</span>
                                            <i><IconName name="gplay" className="icon"/></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="text-footer xmt-16">
                            <p>سایمان دیجیتال، یکی از بهترین فروشگاه های آنلاین با تخصص ویژه در زمینه گوشی و تبلت در
                                کشور بوده و همواره به عنوان مرجع خرید اینترنتی گوشی، تبلت، ساعت هوشمند ، لوازم جانبی
                                و
                                سایر کالاهای دیجیتال به شمار می آید. ما در سایمان دیجیتال با هدف تسهیل روند خرید و
                                ارائه
                                پایین ترین قیمت در زمینه گوشی و سایر کالاهای دیجیتال فعالیت خود را آغاز نمودیم و در
                                تلاشیم تا محصولات بروز در این زمینه را به بهترین شکل ممکن عرضه کنیم. به طوری که با
                                گردآوری تمامی برند های معتبر (اپل، سامسونگ، هواوی، شیائومی، سونی، نوکیا، گوگل، اچ تی
                                سی،
                                بلک بری، کاترپیلار، ایسوس، میزو، موتورولا، ال جی ، وان پلاس و …) در زمینه گوشی،
                                تبلت،
                                ساعت هوشمند و متحد بودن به چهار اصل “مشتری مداری” “پایین ترین قیمت ممکن”، “ضمانت
                                اصالت
                                کالا” ، “ارسال سریع” تجربه خرید مطمئن و راحت را برای مشتریان فراهم می نماییم. ما با
                                ایجاد و تهیه امکاناتی همچون ویدئو آنباکس(جعبه گشایی)، بررسی، مقایسه و نمودار قیمت در
                                محصولات توانسته ایم روند انتخاب و خرید گوشی و یا سایر کالاها را آسانتر کرده و طعمی
                                لذت
                                بخش از خرید اینترنتی را به مشتریان خود منتقل کنیم.
                            </p>
                            <p className="xmt-6">ما، به منظور تسهیل در ارسال و تامین کالا، در شهرهای تهران، تبریز،
                                شیراز
                                و بوشهر مراکز
                                انبارداری کالا ایجاد کردیم تا بتوانیم محصولات موجود در هر انبار را در زمان مناسب تر
                                و
                                سریعتری به دست مصرف کننده نهایی برسانیم و همیشه سعیمان بر آن است که بنا به طیف
                                گسترده
                                این محصولات، در حد امکان "بدون تامین کننده" ارائه خدمت کنیم.
                            </p>
                            <p className="xmt-6">
                                شایان ذکر است هم اکنون دفتر مرکزی ما در تبریز بوده و ارسال کالا برای خرید های بالای
                                یکصد
                                هزار تومان در این شهر به صورت رایگان انجام می پذیرد.
                            </p>
                        </div>
                    </div>
                    <div className="copy-right xpt-10 xpb-20 text-center d-none d-lg-block">
                        <p>کلیه حقوق این سایت متعلق به شرکت کارن تجارت (فروشگاه آنلاین سایمان دیجیتال) است.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
